import React, { useState } from "react";

import { Modal } from "../../../common/Modal";
import {
  UsersIcon,
  BriefcaseIcon,
  MailIcon,
  PhoneIcon,
  MapPinIcon,
} from "../../../../assets/ui/icons";
import { uploadFilePath } from "../../../../constants/s3UploadPath";
import { SectionAddBar } from "./SectionAddBar";
import { EditSectionLayout } from "./EditSectionLayout";
import { EditFooterBar } from "./EditFooterBar";
import { MembershipVerifyNotice } from "./MembershipVerifyNotice";
import { DetailCard } from "./DetailCard";
import { PersonFormModal } from "./PersonFormModal";
import { VerificationModal } from "./VerificationModal";
import { usePeopleSection } from "./usePeopleSection";
import { personKey, personRowValues, personRows, personStatus } from "./peopleFields";

/* Sections 09 and 10 — Authorized Signatory and Key Personnel. */
const ROW_ICONS = {
  name: UsersIcon,
  designation: BriefcaseIcon,
  work_email: MailIcon,
  work_mobile: PhoneIcon,
  nationality: MapPinIcon,
};

export const PeopleSection = ({
  spec,
  onNext,
  onPrev,
  onSkip,
  header,
  className = "",
}) => {
  const { rows, remove, refresh } = usePeopleSection(spec);

  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [verifyOpen, setVerifyOpen] = useState(false);

  const openForm = (record) => {
    setEditing(record || null);
    setFormOpen(true);
  };

  const closeForm = () => {
    setFormOpen(false);
    setEditing(null);
  };

  const cardRows = (record) => {
    const values = personRowValues(record);
    return personRows(spec).map((row) => ({
      key: row.key,
      label: row.label,
      icon: ROW_ICONS[row.key],
      value: values[row.key],
    }));
  };

  return (
    <EditSectionLayout
      className={className}
      header={header}
      footer={
        <EditFooterBar onBack={onPrev} onSkip={onSkip} onContinue={onNext} />
      }
    >
      <h2 className="m-0 text-[16px] font-bold text-[var(--ink)] font-sans">
        {spec.title}
      </h2>

      {/* Members only — see MembershipVerifyNotice. The offer says the
          verification is free WITH YOUR MEMBERSHIP, so it is not shown to
          anyone who does not have one. */}
      <MembershipVerifyNotice onUpload={() => setVerifyOpen(true)} />

      {/* Transcribed: both sections offer Add however many rows exist. */}
      <SectionAddBar
        className="mt-4"
        prompt={spec.addPrompt}
        label={spec.addLabel}
        onAdd={() => openForm(null)}
      />

      {rows.length > 0 && (
        <div className="mt-4 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {rows.map((record) => (
            <DetailCard
              key={personKey(record, spec)}
              status={personStatus(record)}
              rows={cardRows(record)}
              onEdit={() => openForm(record)}
              onDelete={() => remove(record)}
            />
          ))}
        </div>
      )}

      {formOpen && (
        <Modal modalHandle={closeForm} noClose bare>
          <PersonFormModal
            spec={spec}
            editing={editing}
            onClose={closeForm}
            onSaved={() => {
              closeForm();
              refresh();
            }}
          />
        </Modal>
      )}

      {verifyOpen && (
        <Modal modalHandle={() => setVerifyOpen(false)} noClose bare>
          <VerificationModal
            spec={{
              uploadPath: uploadFilePath?.[spec.uploadPath],
              category: spec.category,
            }}
            onClose={() => setVerifyOpen(false)}
            onDone={() => {
              setVerifyOpen(false);
              refresh();
            }}
          />
        </Modal>
      )}
    </EditSectionLayout>
  );
};

export default PeopleSection;
